const SIGLA_MODULO = 'POLISSONOGRAFIA';

const mesclarConfig = (...camadas) => camadas.reduce((acc, camada) => ({ ...acc, ...(camada || {}) }), {});

const identificarSlugParceiro = (pathname, urlsAtivas) => {
    if (!pathname || !Array.isArray(urlsAtivas) || urlsAtivas.length === 0) {
        return null;
    }

    const segmentos = pathname.split('/').filter(Boolean);
    return segmentos.find((segmento) => urlsAtivas.includes(segmento)) || null;
};

const pesquisarValoresInstancia = async (urlBaseConsole, sigla = SIGLA_MODULO, configId) => {
    if (!configId) {
        throw new Error('config_id é obrigatório para carregar valores da instância.');
    }
    const url = `${urlBaseConsole}/modulos/valores/${encodeURIComponent(sigla)}?config_id=${encodeURIComponent(configId)}`;
    const response = await fetch(url, { headers: { 'Content-Type': 'application/json' } });

    if (!response.ok) {
        throw new Error(`Falha ao carregar valores da instância (${response.status})`);
    }

    const body = await response.json();
    const valores = body?.data?.valores;
    if (!valores || typeof valores !== 'object' || Array.isArray(valores) || Object.keys(valores).length === 0) {
        throw new Error('Valores da configuração da instância ausentes ou vazios.');
    }
    return valores;
};

const pesquisarUrlsParceirosAtivas = async (urlBaseConsole) => {
    const url = `${urlBaseConsole}/parceiros/urls-ativas`;
    const response = await fetch(url, { headers: { 'Content-Type': 'application/json' } });

    if (!response.ok) {
        return [];
    }

    const body = await response.json();
    return body?.data?.urls || [];
};

const pesquisarOverrideParceiro = async (urlBaseConsole, slug, sigla = SIGLA_MODULO) => {
    const url = `${urlBaseConsole}/parceiros/${encodeURIComponent(slug)}/config/${encodeURIComponent(sigla)}`;
    const response = await fetch(url, { headers: { 'Content-Type': 'application/json' } });

    if (!response.ok) {
        return null;
    }

    const body = await response.json();
    return body?.data?.valores || null;
};

const resolverConfigInstancia = async (bootstrap) => {
    if (!bootstrap?.config_id) {
        throw new Error('Bootstrap sem campo config_id.');
    }
    const valores = await pesquisarValoresInstancia(
        bootstrap.url_base_console,
        SIGLA_MODULO,
        bootstrap.config_id
    );
    let config = mesclarConfig(bootstrap, valores);

    const urlsAtivas = await pesquisarUrlsParceirosAtivas(bootstrap.url_base_console);
    config.layoutsAlternativos = urlsAtivas;

    const pathname = globalThis.window?.location?.pathname || '';
    const slug = identificarSlugParceiro(pathname, urlsAtivas);
    if (slug) {
        const override = await pesquisarOverrideParceiro(bootstrap.url_base_console, slug);
        if (override) {
            config = mesclarConfig(config, override);
        }
        // O Router usa basename; sem isso a URL perde o sufixo do parceiro após Navigate.
        config.basename = slug;
    } else {
        config.basename = '';
    }

    return config;
};

export default {
    SIGLA_MODULO,
    mesclarConfig,
    identificarSlugParceiro,
    pesquisarValoresInstancia,
    pesquisarUrlsParceirosAtivas,
    pesquisarOverrideParceiro,
    resolverConfigInstancia,
};
